"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCatalogAttribute = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Type guard checking whether the provided object is a {@link ICatalogAttribute}
 *
 * @public
 */
function isCatalogAttribute(obj) {
    return !isEmpty_1.default(obj) && obj.type === "attribute";
}
exports.isCatalogAttribute = isCatalogAttribute;
//# sourceMappingURL=index.js.map